import React from 'react';
import { BookOpen } from 'lucide-react';
export function Header() {
  return <header className="w-full py-6 px-4 border-b border-brown/10 bg-cream/80 backdrop-blur-sm sticky top-0 z-50" data-id="element-49">
      <div className="max-w-3xl mx-auto flex flex-col items-center justify-center text-center space-y-1" data-id="element-50">
        <div className="flex items-center gap-2 text-forest" data-id="element-51">
          <BookOpen size={24} className="opacity-80" data-id="element-52" />
          <h1 className="font-handwriting text-4xl font-bold tracking-wide" data-id="element-53">
            Napftagebuch
          </h1>
        </div>
        <p className="font-serif text-sm text-brown/80 italic" data-id="element-54">
          Ehrliche Geschichten aus dem Hundealltag
        </p>
      </div>
    </header>;
}